import * as HistoryModule from "Modules/HistoryModule";
import * as VehiclesModule from "Modules/VehiclesModule";
import * as React from "react";
import {
  DateComponent,
  DateTimeComponent,
  DistanceComponent,
  DurationComponent
} from "../Composites/_CompositesHelpers";
import {withTranslation} from "react-i18next";
import HistoryRideHeader from "../Components/HistoryRideHeader.Component";
import HistoryRideNav from "../Components/HistoryRideNav.Component";

export const HistoryRideDetailsView = (props: {
  rideDetails: HistoryModule.Types.CarRideDetailsResponse;
  carDetails: VehiclesModule.Types.CarDto;
  onClick: () => void;
  t?: Function
}) => {
  const {onClick, t, rideDetails, carDetails} = props;
  return (
    <>
      <HistoryRideHeader
        //@ts-ignore Na razie nie wiem czy jest możliwość typowania dla tej wersji reduxa komponentów funkcyjnych z composem
        onBack={onClick}
        rideDetails={rideDetails}
      />
      <HistoryRideNav />
      <div className="ride-history__element">
        <div className="ride-history__summary ride-history__summary--vert-margin">
          <img src="/images/icons/ride_icon.svg" width="13"/>
          <DateComponent date={rideDetails.startDate} type={'blue'}/>
          <DurationComponent durationSeconds={rideDetails.durationSeconds}/>
          <DistanceComponent mileage={rideDetails.distanceKilometers}/>
        </div>
        <h4 className="ride-history__title">{t('startDate')}</h4>
        <div className="ride-history__specific">
          <DateTimeComponent date={rideDetails.startDate} alignLeft/>
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('address')}</span>&nbsp;
            <span className="font-bold font-blue">{rideDetails.startAddress}</span>
          </p>
        </div>
        <h4 className="ride-history__title">{t('endDate')}</h4>
        <div className="ride-history__specific">
          <DateTimeComponent date={rideDetails.endDate} alignLeft/>
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('address')}</span>&nbsp;
            <span className="font-bold font-blue">{rideDetails.endAddress}</span>
          </p>
        </div>
        <div className="ride-history__specific">
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('name')}:</span>
            <span className="font-bold">{carDetails?.name}</span>
          </p>
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('model')}:</span> <span
            className="font-bold">{carDetails?.model}</span>
          </p>
          <p className="font-sm mb-5">
                          <span className="font-grey-light">
                              {t('vin')}/{t('Id')}:
                          </span>{' '}
            <span className="font-bold">
                              {carDetails?.vin} [{carDetails?.deviceId}]
                          </span>
          </p>
        </div>
        <div className="ride-history__specific">
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('distanceKilometers')}</span> <span
            className="font-bold font-blue-light">{rideDetails.distanceKilometers.toFixed(2)} km</span>
          </p>
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('distanceKilometersGPS')}:</span> <span
            className="font-bold">{rideDetails.distanceKilometers.toFixed(2)} km</span>
          </p>
        </div>
        <div className="ride-history__specific">
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('averageSpeedKmh')}:</span> <span
            className="font-bold">{typeof rideDetails.averageSpeedKmh == 'string' ? rideDetails.averageSpeedKmh : rideDetails.averageSpeedKmh.toFixed(2)} km/h</span>
          </p>
          <p className="font-sm mb-5">
            <span className="font-grey-light">{t('maxspeed')}:</span> <span
            className="font-bold">{rideDetails.maxSpeedKmh} km/h</span>
          </p>
        </div>
      </div>
    </>
  );
};


export default withTranslation(['carDetails', 'forms'])(HistoryRideDetailsView as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Components/HistoryRideDetails.Component.tsx